<template>
  <div>
    <headerIndex
      v-on:grid="currentView='grid'"
      v-on:list="currentView='list'"
      v-on:map="currentView='map'"
    ></headerIndex>
    <template v-if="currentView == 'list' && path == '/panic_button/sm'">
      <list/>
    </template>
    <template v-if="currentView == 'grid' && path == '/panic_button/sm'">
      <grid/>
    </template>
    <template v-if="currentView == 'map' && path == '/panic_button/sm'">
      <trackerMap/>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    headerIndex: () => import('@core/spore-components/headerIndex/headerIndex.vue'),
    list: () => import('./List.vue'),
    grid: () => import('./Grid.vue'),
    trackerMap: () => import('./Map.vue')
  },
  data () {
    return {
      currentView: 'list',
      path: ''
    }
  },
  created () {
    this.path = this.$route.path
  }
}
</script>
